import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    main: {
      height: '100%',
      paddingTop: spacing(3),
      paddingBottom: spacing(3),
      display: 'flex',
      flexDirection: 'column',
    },
    actionBar: {
      '& > div': {
        display: 'flex',
        alignItems: 'center',
        gap: '2.4rem',
        marginBottom: '1.6rem',
      },

      '& > div:first-child': {
        '& > a': {
          margin: 0,
        },

        '& > :nth-child(2)': {
          flex: 1,
          marginLeft: '7.9rem',
        },
      },

      '& > div:last-child': {
        justifyContent: 'space-between',
      },
    },
    button: {
      width: 'auto',
      minWidth: 'max-content',
      paddingInline: '1.6rem',
      gap: '0.8rem',
    },

    fakeTable: {
      borderCollapse: 'separate',
      borderSpacing: '0 0.8rem',
      marginBottom: spacing(4),
      minWidth: 'max-content',
      padding: '1rem',

      '&  thead > tr > th': {
        border: 'none',
        padding: '1.2rem 0.5rem',
        position: 'sticky',
        top: -1,
        background: 'white',

        '&:first-child': {
          width: '10rem',
        },

        '&:nth-child(2)': {
          width: '380px',
          minWidth: '380px',
        },

        '&:nth-child(3)': {
          width: '300px',
          minWidth: '300px',
        },
        '&:nth-child(4)': {
          width: '180px',
          minWidth: '180px',
        },

        '& > p': {
          fontSize: '1.2rem',
        },
      },
    },
  }),
)
